export default "__VITE_ASSET__BXLqxNyx__"